import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SaleOrderReportDto } from './so-report.dto';
export class SoReportResponseModel extends GlobalResponseObject{
    data?: SaleOrderReportDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: SaleOrderReportDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}